import { render, staticRenderFns } from "./LpuServicesOnlineSwitch.vue?vue&type=template&id=40a057a7&scoped=true&"
import script from "./LpuServicesOnlineSwitch.vue?vue&type=script&lang=js&"
export * from "./LpuServicesOnlineSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LpuServicesOnlineSwitch.vue?vue&type=style&index=0&id=40a057a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a057a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a057a7')) {
      api.createRecord('40a057a7', component.options)
    } else {
      api.reload('40a057a7', component.options)
    }
    module.hot.accept("./LpuServicesOnlineSwitch.vue?vue&type=template&id=40a057a7&scoped=true&", function () {
      api.rerender('40a057a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LpuServices/components/LpuServicesOnlineSwitch.vue"
export default component.exports